/**
 * CustomerGroupUsageType
 */
export enum CustomerGroupUsageType {
    FEEDBACK_FORM_EDITORS = 'feedback-form-editors',
    KNOWLEDGEBASE_PAGE_VIEWERS = 'knowledgebase-page-viewers',
    KNOWLEDGEBASE_PAGE_EDITORS = 'knowledgebase-page-editors'
}
